//
//
//
//
//
//
//
import { setTimeout } from 'timers';
export default {
  data: function data() {
    return {
      isOpen: false,
      isMenuOver: false
    };
  },
  methods: {
    addEvents: function addEvents() {
      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('touchstart', this.handleDocumentClick);
    },
    removeEvents: function removeEvents() {
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('touchstart', this.handleDocumentClick);
    },
    handleDocumentClick: function handleDocumentClick(e) {
      if (!this.isMenuOver) {
        this.toggle();
      }
    },
    toggle: function toggle() {
      this.isOpen = !this.isOpen;
    }
  },
  watch: {
    isOpen: function isOpen(val) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          _this.$emit('show');
        }, 300);
        this.addEvents();
      } else {
        this.removeEvents();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeEvents();
  }
};